var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((5),function(index){return _c('i',{key:index,staticClass:"iconfont icon-xingxing",style:(index <= parseInt(_vm.num) ? 'color:#F07954' : '')})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }